import { useFormikContext } from 'formik';
import React from 'react';

import { useUnsavedChangesGuard } from './UnsavedChangesGuardProvider';

export const FormikDirtyGuard: React.FC = () => {
  const { values, initialValues } = useFormikContext();
  useUnsavedChangesGuard({ values, initialValues });
  return null;
};
